import { render, staticRenderFns } from "./ResourceCalendar.vue?vue&type=template&id=f7f53256"
import script from "./ResourceCalendar.vue?vue&type=script&lang=js"
export * from "./ResourceCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports